import styled, { css } from 'styled-components';
import { theme } from '@theme';

export const Wrapper = styled.label<{ disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;

  ${({ disabled }) =>
          disabled &&
          css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

export const Box = styled.span<{ disabled?: boolean }>`
  width: 18px;
  height: 18px;
  border: 1px solid ${({ disabled }) => disabled ? '#bababa' : theme.palette.primary};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.palette.default};
  transition: background 0.15s, border-color 0.15s ease;

  ${HiddenInput}:focus-visible + & {
    outline: none;
    outline-offset: 2px;
  }

  ${HiddenInput}:checked + & {
    background-color: ${theme.palette.primary};
    color: white;
  }

  svg {
    width: 14px;
    height: 14px;
    stroke: #fff;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;

export const LabelText = styled.span<{ disabled?: boolean }>`
  font-size: 12px;
  color: ${({ disabled }) => (disabled ? '#bababa' : theme.palette.stroke)};
`;
